//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import contentHearder from '../../components/content-hearder';
import { getAuditList, speedUpaudit, unDocodeaudit } from '@/api/miniProgramManagement.js';
export default {
  components: {
    contentHearder,
  },
  filters: {
    format(val) {
      switch (val) {
        case 0:
          return '审核成功';
        case 1:
          return '审核被拒绝';
        case 2:
          return '审核中';
        case 3:
          return '	已撤回';
        case 4:
          return '审核延后';
        default:
          return '';
      }
    },
  },
  data() {
    return {
      arraignment: [],
      page_index: 1,
      page_size: 10,
      total: 0,
      loading: false,
    };
  },
  created() {
    this.getList();
  },
  methods: {
    handleExpedited(val) {
      speedUpaudit({
        appid: val.app_id,
        path: '/wxa/speedupaudit',
        body: JSON.stringify({ auditid: val.audit_id }),
      })
        .then(() => {
          this.$message.success('成功加急');
          this.getList();
        })
        .catch((err) => {
          this.$message.error(err.errmsg);
        });
    },
    handleWithdraw(val) {
      unDocodeaudit({ app_id: val.app_id })
        .then(() => {
          this.$message.success('成功撤回');
          this.getList();
        })
        .catch((err) => {
          this.$message.error(err.errmsg);
        });
    },
    getList() {
      this.loading = true;
      const req = {
        page: this.page_index,
        page_size: this.page_size,
        app_id: this.$route.query.appid,
      };
      getAuditList(req)
        .then((res) => {
          console.log(res);
          this.arraignment = res.list || [];
          this.total = Number(res.total || 0);
          this.loading = false;
        })
        .catch((err) => {
          this.$message.error(err.errmsg);
        });
    },
    handleCurrent(val) {
      this.page_index = val;
      this.getList();
    },
  },
};
